import { AVATAR, AVATAR2 } from "../assets/image";

export function Details({ texts }: any) {
  return (
    <section id="details" className="bg-lxmt-bg lg:py-44 py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-6/12 px-4 mb-8 lg:mb-0">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <img
                src={AVATAR}
                alt="Foto do produto"
                className="w-full h-auto mb-4"
              />
              <div className="text-lg text-gray-600 mb-4 text-center">
                <h1 className="text-2xl font-bold text-gray-900 mb-8">
                  {texts.titleOne}
                </h1>
                {texts.contentOne}
              </div>
            </div>
          </div>
          <div className="w-full lg:w-6/12 px-4 mb-8 lg:mb-0">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <img
                src={AVATAR2}
                alt="Foto do produto"
                className="w-full h-auto mb-4"
              />
              <div className="text-lg text-gray-600 mb-4 text-center">
                <h1 className="text-2xl font-bold text-gray-900 mb-8">
                  {texts.titleTwo}
                </h1>
                {texts.contentTwo}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Details;
